import { useEffect, useState } from "react";
import sanitizedHtml from "sanitize-html";
import { sanitizedHtmlPreferences } from "../../util/constants";
import ValidatedURL from "../../util/url-validation-utility";

const displayNoneCls = "display-none";

const processHTML = (htmlContent, linkNodeMap) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, "text/html");
  const linksToProcess = doc.querySelectorAll("a");
  if (!linksToProcess.length) {
    return doc.body.innerHTML;
  }
  linksToProcess.forEach((link) => {
    const typeOfLink = ValidatedURL.getType(link.getAttribute('href'))
    if(typeOfLink === ValidatedURL.options.invalid) {
      link.remove()
      return
    }
    const linkNode = linkNodeMap instanceof Map && linkNodeMap.get(typeOfLink)
    if (linkNode.className) {
      link.className += (link.className ? " " : "") + linkNode.className;
      link.classList.remove(displayNoneCls);
    }
    const externalNodeChildren = linkNode.cloneNode(true).childNodes;
    if (externalNodeChildren) {
      link.appendChild(...externalNodeChildren);
    }
  });
  return doc.body.innerHTML;
};

const linkNodesForTypesOfExternalLinks = (parentNode) => {
  const map = new Map()
  if(!parentNode) {
    return map
  }
  
  Object.values(ValidatedURL.options).forEach((type) => {
    const linkNode = parentNode.querySelector(`a[data-type="${type}"]`);
    if (linkNode) {
      map.set(type, linkNode)
    }
  })

  return map
}

const useHTMLProcessor = ({ 
  externalLinkRef,
  uuid,
  html,
  cache
 }) => {
  const sanitizedHTML = sanitizedHtml(html, sanitizedHtmlPreferences);
  const [freshHTML, setFreshHTML] = useState(cache);

  useEffect(() => {
    if(cache?.[uuid]?.length)  {
      setFreshHTML(existing => {
        return {
          ...existing,
          [uuid]: cache?.[uuid]
        }
      })
    } else {
      const linkNodes = linkNodesForTypesOfExternalLinks(externalLinkRef?.current)
      const modifiedHTML = linkNodes?.size && processHTML(sanitizedHTML, linkNodes);

      setFreshHTML(existing => {
        const newValues = {
          ...existing,
          [uuid]: modifiedHTML || sanitizedHTML
        }
        return newValues
      });
    }
  }, [cache, externalLinkRef, sanitizedHTML, uuid]);
  
  return {
    modifiedHTML: freshHTML,
    _sanitizedHTML: sanitizedHTML
  };
};

export default useHTMLProcessor;
